import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, Input, signal, Output, EventEmitter, inject } from '@angular/core';
import { CampaignWithCountDto } from '../../../../common/general-types/campaigns.dto';
import { BriefApplicationResponseDto, BriefResponseDto } from '../../../../common/general-types/briefs.dto';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { take } from 'rxjs';
import { ImageService } from '../../../../services/image/image.service';
import { BriefService } from '../../../../services/brief/brief.service';
import { BriefApplicationService } from '../../../../services/brief-application/brief-application.service';
import { AlertService } from '../../../../atoms/alert/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-promote-to-brief',
  standalone: true,
  imports: [],
  templateUrl: './promote-to-brief.component.html',
  styleUrl: './promote-to-brief.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PromoteToBriefComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('drawerDialog', { static: false }) drawerDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('openDrawerButton', { static: false }) openDrawerButton?: ElementRef<HTMLButtonElement>;

  @Input() currentBriefId: string | undefined;
  @Output() close = new EventEmitter<void>();

  private dialogCloseHandler?: () => void;

  allCampaigns = signal<CampaignWithCountDto[] | undefined>(undefined);
  displayCampaigns = signal<CampaignWithCountDto[] | undefined>(undefined);

  selectedBrief = signal<BriefResponseDto | undefined>(undefined);

  runningPromote = signal<boolean>(false);

  selectedCampaign = signal<CampaignWithCountDto | undefined>(undefined);
  linkedBriefs = signal<BriefResponseDto[] | undefined>(undefined);


  /** Services */
  private router = inject(Router);
  private currentUserService = inject(CurrentUserService);
  private campaignService = inject(CampaignService);
  public imageService = inject(ImageService);
  public briefService = inject(BriefService);
  public alertService = inject(AlertService);
  private briefApplicationService = inject(BriefApplicationService);
  /** Services - END */



  ngOnInit(): void {
    this.getAllCampaigns();
  }

  getAllCampaigns() {
    console.log('getAllCampaigns(): ', this.currentUserService.focussedBrand.id);
    this.campaignService.getAllBusinessCampaigns(this.currentUserService.focussedBrand.id).pipe(take(1)).subscribe((response: any) => {
      console.log('All Campaigns:', response);
      this.allCampaigns.set(response);
    });
  }

  selectCampaign(campaign: CampaignWithCountDto | undefined) {
    this.selectedCampaign.set(campaign);
    this.getLinkedBriefs();
  }

  getLinkedBriefs() {
    if (this.selectedCampaign()) {
      this.campaignService.getLinkedBriefs(this.selectedCampaign()!.id).pipe(take(1)).subscribe((response: any) => {
        console.log('Linked Briefs:', response);
        this.linkedBriefs.set(response);
      }, (err: any) => {
        console.error('Error fetching linked briefs:', err);
      });
    }
  }

  selectBrief(brief: BriefResponseDto | undefined) {
    this.selectedBrief.set(brief);
  }

  removeCreator(creator: any) {
    this.briefService.creatorsToPromote.set(this.briefService.creatorsToPromote().filter((c: BriefApplicationResponseDto) => c.id !== creator.id));
  }

  promoteCreators() {
    console.log('promoteCreators(): ', this.briefService.creatorsToPromote());
    this.runningPromote.set(true);

    if (this.selectedCampaign() && this.selectedBrief() && this.briefService.creatorsToPromote().length > 0) {
      const creators = this.briefService.creatorsToPromote().map((c: BriefApplicationResponseDto) => c.creator?.blazeFirebaseUid);
      const briefId = this.selectedBrief()?.id;
      const campaignId = this.selectedCampaign()?.id;

      const payload = {
        applications: this.getApplicationIds(),
        creators: creators,
        toBrief: briefId,
        fromBrief: this.currentBriefId,
        campaignId: campaignId
      }

      this.briefApplicationService.promoteCreators(payload).pipe(take(1)).subscribe((response: any) => {
        console.log('response: ', response);
        this.runningPromote.set(false);
        this.promotionSuccess(response, briefId!);
      })
    }
  }

  getApplicationIds(): { creatorId: string, applicationId: string, hiredPricing: any }[] {
    return this.briefService.creatorsToPromote().map((c: BriefApplicationResponseDto) => ({
      creatorId: c.creator?.blazeFirebaseUid ?? '',
      applicationId: c.id ?? '',
      hiredPricing: c.hiredBriefPricing ?? undefined
    }));
  }

  async promotionSuccess(promotedRes: { completed: number, failed: number, total: number }, successBriefId: string) {
    this.briefService.creatorsToPromote.set([]);
    const confirm = await this.alertService.confirm({
      title: 'Woohoo! 🥳',
      message: `${promotedRes.completed} creators promoted to brief, ${promotedRes.failed} failed.`,
      confirmText:'Go To Brief',
      cancelText: 'Close',
      type: 'confirm',
      icon: 'info'
    });

    if (confirm) {
      this.closeDrawer();
      this.router.navigate([`/manage-brief/${successBriefId}`]);
    } else {
      this.closeDrawer();
    }
  }


  ngAfterViewInit(): void {
    if (this.openDrawerButton?.nativeElement) {
      setTimeout(() => {
        this.openDrawerButton?.nativeElement.click();
      }, 0);
    }

    if (this.drawerDialog?.nativeElement) {
      this.dialogCloseHandler = () => {
        this.closeDrawer();
      };
      this.drawerDialog.nativeElement.addEventListener('close', this.dialogCloseHandler);
    }
  }

  closeDrawer() {
    this.close.emit();
  }

  ngOnDestroy(): void {
    if (this.drawerDialog?.nativeElement && this.dialogCloseHandler) {
      this.drawerDialog.nativeElement.removeEventListener('close', this.dialogCloseHandler);
    }
  }
}
